import { render, staticRenderFns } from "./companyInfoMst.vue?vue&type=template&id=6a95b654&scoped=true"
import script from "./companyInfoMst.vue?vue&type=script&lang=js"
export * from "./companyInfoMst.vue?vue&type=script&lang=js"
import style0 from "./companyInfoMst.vue?vue&type=style&index=0&id=6a95b654&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a95b654",
  null
  
)

export default component.exports